import React, { useEffect } from 'react'
import HostNav from "../components/hostComponents/HostNav";
import PropertyDetailsComponent from "../components/hostComponents/PropertyDetailsComponent";
import { useNavigate } from 'react-router-dom'
import { useSelector } from "react-redux";

function PropertyDetailsScreen() {
  const navigate = useNavigate()
  const { hostInfo } = useSelector((state) => state.host);

  useEffect(() => {
    if (!hostInfo) {
      navigate('/login')
    }
  }, [hostInfo, navigate]);

  return (
    <div className="min-h-screen bg-gray-50">
      <HostNav />
      <PropertyDetailsComponent />
    </div>
  )
}

export default PropertyDetailsScreen